import React from "react";
import { Link } from "react-router-dom";
import { BedDouble, UtensilsCrossed, Smartphone, Building2, ArrowUpRight, ArrowRight } from "lucide-react";

const VENTURES = [
  {
    icon: BedDouble,
    tag: "Munnar",
    title: "Auracrest Haven",
    desc: "Luxury home-stay cottages and deluxe rooms nestled on a hillock near Sengulam Dam, Munnar.",
    cta: "Explore Stay",
    type: "anchor",
    href: "#about",
  },
  {
    icon: UtensilsCrossed,
    tag: "Fine Dining",
    title: "SpyzzZ Restaurant",
    desc: "Our fine-dining restaurant at Auracrest Haven, Munnar \u2014 delectable dishes amid natural beauty.",
    cta: "Visit SpyzzZ",
    type: "external",
    href: "https://www.finediningmunnar.com/",
  },
  {
    icon: Smartphone,
    tag: "Food Delivery",
    title: "Spyzzie",
    desc: "Fresh, healthy homemade food delivered across Anachal, Sengulam, ET City, Bison Valley & 20+ areas.",
    cta: "Order at spyzzie.in",
    type: "external",
    href: "https://spyzzie.in",
  },
  {
    icon: Building2,
    tag: "Kochi City",
    title: "Morning Star Metro Home Stay Kochi",
    desc: "Premium whole-house home-stay with all facilities in the heart of Kochi city, Kerala.",
    cta: "View Property",
    type: "route",
    href: "/morning_star_metro_home_stay_kochi",
  },
];

const CardInner = ({ v }) => {
  const Icon = v.icon;
  const External = v.type === "external";
  return (
    <>
      <div className="w-12 h-12 rounded-xl bg-[#e3faf7] flex items-center justify-center mb-5">
        <Icon className="w-6 h-6 text-[#17a89b]" />
      </div>
      <span className="inline-block text-[11px] font-semibold tracking-[0.14em] uppercase text-[#17a89b] mb-2">
        {v.tag}
      </span>
      <h3 className="text-xl font-bold text-neutral-900 mb-2">{v.title}</h3>
      <p className="text-neutral-600 leading-7 text-sm mb-5 flex-1">{v.desc}</p>
      <span className="inline-flex items-center gap-1 text-[#17a89b] font-semibold text-sm">
        {v.cta} {External ? <ArrowUpRight className="w-4 h-4" /> : <ArrowRight className="w-4 h-4" />}
      </span>
    </>
  );
};

const Ventures = () => (
  <section id="resorts" className="py-20 md:py-28 bg-white">
    <div className="max-w-7xl mx-auto px-5 md:px-8">
      <div className="text-center mb-14">
        <p className="text-xs font-semibold tracking-[0.25em] uppercase text-[#17a89b] mb-4">
          Auracrest Haven Resorts
        </p>
        <h2 className="text-3xl md:text-5xl font-extrabold text-neutral-900 mb-4">
          One Family, Four Experiences
        </h2>
        <p className="text-neutral-600 max-w-2xl mx-auto leading-8">
          Auracrest Haven Resorts is a family of hospitality ventures across Kerala &mdash; with
          more properties on the way. Discover everything we offer.
        </p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {VENTURES.map((v, i) => {
          const cls =
            "group bg-neutral-50 rounded-2xl p-7 flex flex-col h-full shadow-sm hover:shadow-md hover:-translate-y-1 transition-all duration-300";
          if (v.type === "route") {
            return (
              <Link key={i} to={v.href} className={cls}>
                <CardInner v={v} />
              </Link>
            );
          }
          return (
            <a
              key={i}
              href={v.href}
              target={v.type === "external" ? "_blank" : undefined}
              rel={v.type === "external" ? "noopener noreferrer" : undefined}
              className={cls}
            >
              <CardInner v={v} />
            </a>
          );
        })}
      </div>
    </div>
  </section>
);

export default Ventures;
